import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { useImmer } from "use-immer";

import { EXPERIMENT_ROUTES, PERSONALIZATION_ROUTES } from "../routes/routes";

export const urlRegex =
  /^(http(s):\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;

export const useIsEditPage = () => {
  const location = useLocation();
  const [isEditPage, setIsEditPage] = useImmer<boolean>(false);

  useEffect(() => {
    setIsEditPage(isUserOnEditPage(location));
  }, [location.pathname]);

  return isEditPage;
};

export const useEditPageExperienceId = () => {
  const location = useLocation();
  const [editPageExperienceId, setEditPageExperienceId] = useImmer<string>("");

  useEffect(() => {
    setEditPageExperienceId(
      isUserOnEditPage(location)
        ? location.pathname.slice(location.pathname.indexOf("/", 1) + 1)
        : ""
    );
  }, [location.pathname]);

  return editPageExperienceId;
};

export const isUserOnEditPage = (location: { pathname: string }) => {
  return [
    EXPERIMENT_ROUTES.Experiment_Id,
    PERSONALIZATION_ROUTES.Personalization_Id,
  ].some((route) =>
    matchPath(
      route.endsWith("?") ? route.slice(0, -1) : route,
      location.pathname
    )
  );
};

export const LEGACY_ONSITE_EDITOR_DROP_DEAD_DATE = "August 18, 2026";
